module.exports = __webpack_public_path__ + "img/ch14_07_摘菜提水.7d10b0d9.jpg";